import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';
import classNames from 'classnames';
import { Flex } from '@mantine/core';
import LineChart from 'src/components/LineChart';
import { Pie } from 'react-chartjs-2';
import { Chart, ChartData, ChartOptions } from 'chart.js';
import "chart.js/auto";
interface Props {
  number_passed: number | undefined;
  cant_tested: number | undefined;
  number_that_fails: number | undefined;
  title?: string,
  colors? : Array<string>
}

const MultiFactorProgress: FC<Props> = ({
  number_passed = 0, // Default to 0 if undefined
  cant_tested = 0, // Default to 0 if undefined
  number_that_fails = 0, // Default to 0 if undefined
  title = "",
  colors =  ['#035e11b0', '#da604e', '#2A2B4B']
}: Props): JSX.Element => {

  const [t] = useTranslation('progressBars');

  // Define the data
  const data: ChartData<'pie'> = {
    // labels: [t('Passed'), t('Failed'), t('Untestable')],
    datasets: [{
      label: t('TestResults') || "",
      data: [number_passed, number_that_fails, cant_tested],
      backgroundColor: colors ?? ['#035e11b0', '#da604e', '#2A2B4B'],
      borderColor: ['#ffffff'],
      borderWidth: 2,
    }],


  };

  // Define the options
  const options: ChartOptions<'pie'> = {
    maintainAspectRatio: false,

    responsive: true,
    plugins: {
      datalabels: {
        color: '#fff'
      },
      legend: {
        position: 'top',
        labels: {
          color: '#222'
        }
      },
      tooltip: {
        bodyColor: '#fff',
        backgroundColor: '#000'
      },

      title: {
        display: true,
        text: title,
        color: '#222',
        font: {
          size: 24,
          weight: 'bold',
          style: 'normal'
        },
      }
    }
  };
  return (
    <div className={styles.chartContainer}>
      <Pie data={data} options={options} id='Vially_Accessibility_Score' />
    </div>
  );
};

export default MultiFactorProgress;
